// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"8d7cd7eb","250":"2a1dbf09","407":"3db81f51","436":"1b7e0907","453":"f394a27d","455":"2b9dbaca","501":"1eb17970","595":"1a6cca41","606":"dcdb9f72","691":"a28e7b6d","821":"f010bf0b","880":"e2c32178","925":"48e4248b","969":"903ff162"}[chunkId] + ".chunk.js";
};